import { Route, Switch, useLocation } from "react-router-dom";
import Swp from "./Swp";
import Stp from "./Stp";
import Redemption from "./Redemption";
import SwitchTransaction from "./Switch";
import CommonBreadCrumb from "../breadCrumbs";
import AdditionalPurchase from "./AdditionalPurchase";
import NewPurchase from "./NewPurchase";
import Sip from "./Sip";

const ROUTES = [
  { path: "/re-initiate/swp", component: Swp },
  { path: "/re-initiate/stp", component: Stp },
  { path: "/re-initiate/redemption", component: Redemption },
  { path: "/re-initiate/switch", component: SwitchTransaction },
  { path: "/re-initiate/new-purchase", component: NewPurchase },
  { path: "/re-initiate/additional-purchase", component: AdditionalPurchase },
  { path: "/re-initiate/sip", component: Sip },
];

const breadcrumbNameMap = {
  "/re-initiate": {
    to: "/dashboard",
    title: "Reinitiate",
  },
  "/re-initiate/swp": {
    to: "/dasboard",
    title: "SWP",
  },
  "/re-initiate/stp": {
    to: "/dasboard",
    title: "STP",
  },
  "/re-initiate/redemption": {
    to: "/dasboard",
    title: "Redemption",
  },
  "/re-initiate/switch": {
    to: "/dasboard",
    title: "Switch",
  },
  "/re-initiate/additiona-purchase": {
    to: "/dasboard",
    title: "Additional-Purchase",
  },
  "/re-initiate/new-purchase": {
    to: "/dasboard",
    title: "New-Purchase",
  },
};

export default function ReinitateRouter() {
  const { pathname } = useLocation();
  return (
    <div
      className="table_border"
      style={{
        margin: "32px 48px",
      }}
    >
      <CommonBreadCrumb
        breadcrumbNameMap={breadcrumbNameMap}
        pathnames={pathname.split("/").filter(Boolean)}
      />
      <Switch>
        {ROUTES.map((routeProps, index) => (
          <Route {...routeProps} exact key={index} />
        ))}
      </Switch>
    </div>
  );
}
